import React, { useState } from 'react';
import axios from '../../axios/axiosconf';
import ModalCIE10 from './ModalCIE10';
import SearchableSelect from './SearchableSelect';
import ModalRipsExito from './ModalRipsExito';

function RegistroRipsSinFev({ paciente }) {
    const [formData, setFormData] = useState({
        paciente_id: '',
        nombre_paciente: '',
        tipo: 'CC',
        ndocumento: '',
        fecha: '',
        incapacidad: 'NO',
        tipo_usuario: '12',
        profesionalcode: '',
        sede: '',
        tipo_consulta: false,
        tipo_procedimiento: false,
        cupsc: '',
        cupsp: '',
        cie10c: '',
        cie10c1: '',
        cie10c2: '',
        cie10c3: '',
        cie10p: '',
        cie10p1: '',
        cie10pc: ''
    });

    // Llenar datos del paciente cuando se reciben las props
    React.useEffect(() => {
        if (paciente) {
            const nombreCompleto = `${paciente.primerNombre || ''} ${paciente.segundoNombre || ''} ${paciente.primerApellido || ''} ${paciente.segundoApellido || ''}`.trim();
            setFormData(prev => ({
                ...prev,
                paciente_id: paciente.id || '',
                nombre_paciente: nombreCompleto,
                tipo: paciente.tipoDocumento || 'CC',
                ndocumento: paciente.numeroDocumento || '',
                fecha: new Date().toISOString().split('T')[0]
            }));
        }
    }, [paciente]);

    // Cargar datos de API
    React.useEffect(() => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const config = {
            headers: { Authorization: 'Bearer ' + userdata.access_token }
        };

        // Cargar profesionales
        axios.get('/usuarios?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setProfesionales(response.data);
                }
            })
            .catch(error => console.log('Error cargando profesionales:', error));

        // Cargar sedes
        axios.get('/sedes?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setSedes(response.data);
                }
            })
            .catch(error => console.log('Error cargando sedes:', error));
        
        // Cargar Servicios desde API
        axios.get('/rips-servicios?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setServicios(response.data);
                }
            })
            .catch(error => console.log('Error cargando servicios:', error));
        
        // Cargar Finalidad Consulta desde API
        axios.get('/rips-finalidad-consulta?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setFinalidadConsulta(response.data);
                    setFinalidadProcedimiento(response.data); // Usar el mismo para procedimiento
                }
            })
            .catch(error => console.log('Error cargando finalidad consulta:', error));
        
        // Cargar Causa Externa desde API
        axios.get('/rips-causa-externa?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setCausaExterna(response.data);
                }
            })
            .catch(error => console.log('Error cargando causa externa:', error));
    }, []);

    const [showConsulta, setShowConsulta] = useState(false);
    const [showProcedimiento, setShowProcedimiento] = useState(false);

    // Estados para modales
    const [showModalConsulta, setShowModalConsulta] = useState(false);
    const [showModalProcedimiento, setShowModalProcedimiento] = useState(false);
    const [listaConsultas, setListaConsultas] = useState([]);
    const [listaProcedimientos, setListaProcedimientos] = useState([]);

    // Estados para modales CIE10
    const [showModalCIE10, setShowModalCIE10] = useState(false);
    const [cie10Field, setCie10Field] = useState('');

    // Modal de éxito
    const [showModalExito, setShowModalExito] = useState(false);
    const [ripsGuardado, setRipsGuardado] = useState(null);

    // Estados para datos de API
    const [profesionales, setProfesionales] = useState([]);
    const [sedes, setSedes] = useState([]);
    
    // Estados para JSON de RIPS
    const [servicios, setServicios] = useState([]);
    const [finalidadConsulta, setFinalidadConsulta] = useState([]);
    const [finalidadProcedimiento, setFinalidadProcedimiento] = useState([]);
    const [causaExterna, setCausaExterna] = useState([]);


    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        let newFormData = {
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        };


        setFormData(newFormData);

        if (name === 'tipo_consulta') {
            setShowConsulta(checked);
        } else if (name === 'tipo_procedimiento') {
            setShowProcedimiento(checked);
        }
    };



    const cargarConsultas = async () => {
        try {
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            const config = {
                headers: { Authorization: 'Bearer ' + userdata.access_token },
                params: { uid: userdata.user_id, clasificacionrips: 1 }
            };
            const response = await axios.get('/lista-precio-rips', config);
            setListaConsultas(response.data);
        } catch (error) {
            console.error('Error cargando consultas:', error);
        }
    };

    const cargarProcedimientos = async () => {
        try {
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            const config = {
                headers: { Authorization: 'Bearer ' + userdata.access_token },
                params: { uid: userdata.user_id, clasificacionrips: 2 }
            };
            const response = await axios.get('/lista-precio-rips', config);
            setListaProcedimientos(response.data);
        } catch (error) {
            console.error('Error cargando procedimientos:', error);
        }
    };

    const abrirModalConsulta = () => {
        cargarConsultas();
        setShowModalConsulta(true);
    };

    const abrirModalProcedimiento = () => {
        cargarProcedimientos();
        setShowModalProcedimiento(true);
    };

    const seleccionarConsulta = (codigo) => {
        setFormData(prev => ({ ...prev, cupsc: codigo }));
        setShowModalConsulta(false);
    };

    const seleccionarProcedimiento = (codigo) => {
        setFormData(prev => ({ ...prev, cupsp: codigo }));
        setShowModalProcedimiento(false);
    };

    const abrirModalCIE10 = (fieldName) => {
        setCie10Field(fieldName);
        setShowModalCIE10(true);
    };

    const seleccionarCIE10 = (codigo) => {
        setFormData(prev => ({ ...prev, [cie10Field]: codigo }));
        setShowModalCIE10(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validaciones básicas
        if (!formData.tipo_consulta && !formData.tipo_procedimiento) {
            alert('Debe seleccionar al menos Consulta o Procedimiento');
            return;
        }

        if (!formData.profesionalcode || !formData.sede) {
            alert('Por favor complete los campos de Profesional y Sede');
            return;
        }

        // Validar Consulta
        if (formData.tipo_consulta) {
            if (!formData.cupsc || !formData.cie10c) {
                alert('Para Consulta, debe seleccionar el Código CUPS y el Diagnóstico Principal');
                return;
            }
        }

        // Validar Procedimiento
        if (formData.tipo_procedimiento) {
            if (!formData.cupsp || !formData.cie10p) {
                alert('Para Procedimiento, debe seleccionar el Código CUPS y el Diagnóstico Principal');
                return;
            }
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token,
                'Content-Type': 'application/json'
            }
        };

        const ripsData = {
            ...formData,
            uid: userdata.user_id
        };

        try {
            const response = await axios.post('/rips-sin-fev', ripsData);
            if (response.status === 200 || response.status === 201) {
                // Mostrar modal de éxito
                setRipsGuardado({
                    rips_id: response.data.rips_id,
                    factura_id: null,
                    tipo: 'sin_fev',
                    estado: 1 // RIPS sin factura
                });
                setShowModalExito(true);
            }
        } catch (error) {
            console.error('Error al guardar:', error);
            alert('Error al guardar RIPS: ' + (error.response?.data?.message || error.message));
        }
    };

    const handleDescargar = async (ripsId) => {
        try {
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            
            // Determinar el endpoint según el estado y factura
            let endpoint;
            let fileName;
            
            if (ripsGuardado && (ripsGuardado.estado === 2 || ripsGuardado.estado === 4) && ripsGuardado.factura_id) {
                // RIPS por convenio con factura - descargar agrupado
                endpoint = `/rips/convenio/${ripsGuardado.factura_id}/descargar`;
                fileName = `rips_convenio_${ripsGuardado.factura_id}`;
            } else {
                // RIPS individual
                endpoint = `/rips/${ripsId}/descargar`;
                fileName = `rips_${ripsId}`;
            }
            
            const response = await axios.get(endpoint, {
                params: { uid: userdata.user_id },
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            
            const contentType = response.headers['content-type'];
            const finalFileName = contentType.includes('zip') 
                ? `${fileName}.zip` 
                : `${fileName}.json`;
            
            link.setAttribute('download', finalFileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error descargando RIPS:', error);
            alert('Error al descargar el archivo RIPS');
        }
    };

    const handleEnviar = async (ripsId) => {
        try {
            const response = await axios.post(`/rips/${ripsId}/enviar`);
            
            if (response.data.success) {
                alert(`RIPS enviado exitosamente\n\nEstado anterior: ${response.data.estado_anterior}\nEstado nuevo: ${response.data.estado_nuevo}`);
                setShowModalExito(false);
            }
        } catch (error) {
            console.error('Error enviando RIPS:', error);
            alert('Error al enviar RIPS: ' + (error.response?.data?.message || error.message));
        }
    };

    const handleCerrarModal = () => {
        setShowModalExito(false);
    };

    return (
        <div className="container-fluid">
            <form onSubmit={handleSubmit}>
                <div className="card card-info card-outline">
                    <div className="card-header"><b>Información del Paciente</b></div>
                    <div className="card-body">
                        <div className="form-group">
                            <button type="button" className="btn btn-info">
                                <i className="fas fa-edit"></i>Seleccionar Paciente
                            </button>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Nombre del Paciente *</label>
                                    <input type="text" name="nombre_paciente" className="form-control text-uppercase"
                                        value={formData.nombre_paciente} readOnly />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label>Tipo *</label>
                                    <select name="tipo" className="form-control" value={formData.tipo} onChange={handleInputChange} required>
                                        <option value="CC">CC</option>
                                        <option value="CE">CE</option>
                                        <option value="PA">PA</option>
                                        <option value="PE">PE</option>
                                        <option value="RC">RC</option>
                                        <option value="TI">TI</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label>N°Documento *</label>
                                    <input type="text" name="ndocumento" className="form-control"
                                        value={formData.ndocumento} readOnly />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card card-info card-outline">
                    <div className="card-header"><b>Información General</b></div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label>Fecha *</label>
                                    <input type="date" name="fecha" className="form-control"
                                        value={formData.fecha} onChange={handleInputChange} required />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>Incapacidad *</label>
                                    <select name="incapacidad" className="form-control" value={formData.incapacidad} onChange={handleInputChange} required>
                                        <option value="NO">NO</option>
                                        <option value="SI">SI</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label>Tipo de Usuario *</label>
                                    <select name="tipo_usuario" className="form-control" value={formData.tipo_usuario} onChange={handleInputChange} required>
                                        <option value="12">Particular</option>
                                        <option value="01">Contributivo cotizante</option>
                                        <option value="02">Contributivo beneficiario</option>
                                        <option value="03">Contributivo adicional</option>
                                        <option value="04">Subsidiado</option>
                                        <option value="05">No afiliado</option>
                                        <option value="06">Especial o Excepcion cotizante</option>
                                        <option value="07">Especial o Excepcion beneficiario</option>
                                        <option value="08">Personas privadas de la libertad a cargo del Fondo Nacional de Salud</option>
                                        <option value="09">Tomador / Amparado ARL</option>
                                        <option value="10">Tomador / Amparado SOAT</option>
                                        <option value="11">Tomador / Amparado Planes voluntarios de salud</option>
                                        <option value="13">Especial o Exepcion no cotizante Ley 352 de 1997</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>Profesional *</label>
                                    <select name="profesionalcode" className="form-control" value={formData.profesionalcode} onChange={handleInputChange} required>
                                        <option value="">Seleccionar...</option>
                                        {profesionales.map(prof => (
                                            <option key={prof.id} value={prof.id}>{prof.name} {prof.lastname}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label>Sede *</label>
                                    <select name="sede" className="form-control" value={formData.sede} onChange={handleInputChange} required>
                                        <option value="">Seleccionar...</option>
                                        {sedes.map(s => (
                                            <option key={s.id} value={s.id}>{s.nombre}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>

                        <hr />
                        <label><b>Selecciona el Tipo Servicio:</b></label><br />
                        <label className={`btn ${formData.tipo_consulta ? 'btn-info' : 'btn-secondary'}`} style={{ marginRight: '8px' }}>
                            <input type="checkbox" name="tipo_consulta" checked={formData.tipo_consulta} onChange={handleInputChange} className="d-none" />
                            <i className="far fa-calendar-check mr-1"></i> Consulta
                        </label>
                        <label className={`btn ${formData.tipo_procedimiento ? 'btn-info' : 'btn-secondary'}`} style={{ marginRight: '8px' }}>
                            <input type="checkbox" name="tipo_procedimiento" checked={formData.tipo_procedimiento} onChange={handleInputChange} className="d-none" />
                            <i className="fas fa-procedures mr-1"></i> Procedimiento
                        </label>
                    </div>
                </div>

                {showConsulta && (
                    <div className="card card-info card-outline">
                        <div className="card-header"><b>Información de la Consulta</b></div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Código de Consulta *</label>
                                        <div className="input-group">
                                            <input type="text" name="cupsc" className="form-control" placeholder="Seleccione, Haciendo Click en el Icono" value={formData.cupsc} readOnly />
                                            <div className="input-group-append">
                                                <button type="button" className="btn btn-info" onClick={abrirModalConsulta}>
                                                    <i className="fas fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Diagnóstico Principal *</label>
                                        <div className="input-group">
                                            <input type="text" name="cie10c" className="form-control" placeholder="Seleccione, Haciendo Click en el Icono" value={formData.cie10c} readOnly />
                                            <div className="input-group-append">
                                                <button type="button" className="btn btn-info" onClick={() => abrirModalCIE10('cie10c')}>
                                                    <i className="fas fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Diagnóstico Relacionado 1</label>
                                        <div className="input-group">
                                            <input type="text" name="cie10c1" className="form-control" value={formData.cie10c1} readOnly />
                                            <div className="input-group-append">
                                                <button type="button" className="btn btn-info" onClick={() => abrirModalCIE10('cie10c1')}>
                                                    <i className="fas fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Diagnóstico Relacionado 2</label>
                                        <div className="input-group">
                                            <input type="text" name="cie10c2" className="form-control" value={formData.cie10c2} readOnly />
                                            <div className="input-group-append">
                                                <button type="button" className="btn btn-info" onClick={() => abrirModalCIE10('cie10c2')}>
                                                    <i className="fas fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Diagnóstico Relacionado 3</label>
                                        <div className="input-group">
                                            <input type="text" name="cie10c3" className="form-control" value={formData.cie10c3} readOnly />
                                            <div className="input-group-append">
                                                <button type="button" className="btn btn-info" onClick={() => abrirModalCIE10('cie10c3')}>
                                                    <i className="fas fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Modalidad de Atención *</label>
                                        <select name="modalidad_consulta" className="form-control" required>
                                            <option value="01">INTRAMURAL</option>
                                            <option value="02">EXTRAMURAL UNIDAD MÓVIL</option>
                                            <option value="03">EXTRAMURAL DOMICILIARIA</option>
                                            <option value="04">EXTRAMURAL JORNADA DE SALUD</option>
                                            <option value="06">TELEMEDICINA INTERACTIVA</option>
                                            <option value="07">TELEMEDICINA NO INTERACTIVA</option>
                                            <option value="08">TELEMEDICINA TELEXPERTICIA</option>
                                            <option value="09">TELEMEDICINA TELEMONITOREO</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Grupo de Servicios *</label>
                                        <select name="grupo_servicios" className="form-control" required>
                                            <option value="01">CONSULTA EXTERNA</option>
                                            <option value="02">APOYO DIAGNÓSTICO Y COMPLEMENTACIÓN TERAPÉUTICA</option>
                                            <option value="03">INTERNACIÓN</option>
                                            <option value="04">QUIRÚRGICO</option>
                                            <option value="05">ATENCIÓN INMEDIATA</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <SearchableSelect
                                        name="servicios"
                                        value={formData.servicios}
                                        onChange={handleInputChange}
                                        options={servicios}
                                        label="Servicios"
                                        placeholder="Seleccione un servicio..."
                                        required={true}
                                        helpText="Busque por código o nombre del servicio"
                                    />
                                </div>
                                <div className="col-md-12">
                                    <SearchableSelect
                                        name="finalidadconsulta"
                                        value={formData.finalidadconsulta}
                                        onChange={handleInputChange}
                                        options={finalidadConsulta}
                                        label="Finalidad Consulta"
                                        placeholder="Seleccione la finalidad..."
                                        helpText="Busque por código o nombre"
                                    />
                                </div>
                                <div className="col-md-12">
                                    <SearchableSelect
                                        name="causaexternaconsulta"
                                        value={formData.causaexternaconsulta}
                                        onChange={handleInputChange}
                                        options={causaExterna}
                                        label="Causa Externa Consulta"
                                        placeholder="Seleccione la causa externa..."
                                        helpText="Busque por código o nombre"
                                    />
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Tipo de Diagnóstico *</label>
                                        <select name="tipo_diagnostico" className="form-control" required>
                                            <option value="01">IMPRESIÓN DIAGNÓSTICA</option>
                                            <option value="02">CONFIRMADO NUEVO</option>
                                            <option value="03">CONFIRMADO REPETIDO</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {showProcedimiento && (
                    <div className="card card-info card-outline">
                        <div className="card-header"><b>Información del Procedimiento</b></div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Código de Procedimiento *</label>
                                        <div className="input-group">
                                            <input type="text" name="cupsp" className="form-control" placeholder="Seleccione, Haciendo Click en el Icono" value={formData.cupsp} readOnly />
                                            <div className="input-group-append">
                                                <button type="button" className="btn btn-info" onClick={abrirModalProcedimiento}>
                                                    <i className="fas fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Diagnóstico Procedimiento *</label>
                                        <div className="input-group">
                                            <input type="text" name="cie10p" className="form-control" placeholder="Seleccione, Haciendo Click en el Icono" value={formData.cie10p} readOnly />
                                            <div className="input-group-append">
                                                <button type="button" className="btn btn-info" onClick={() => abrirModalCIE10('cie10p')}>
                                                    <i className="fas fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Diagnóstico Relacionado 1</label>
                                        <div className="input-group">
                                            <input type="text" name="cie10p1" className="form-control" value={formData.cie10p1} readOnly />
                                            <div className="input-group-append">
                                                <button type="button" className="btn btn-info" onClick={() => abrirModalCIE10('cie10p1')}>
                                                    <i className="fas fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Diagnóstico Complicación</label>
                                        <div className="input-group">
                                            <input type="text" name="cie10pc" className="form-control" value={formData.cie10pc} readOnly />
                                            <div className="input-group-append">
                                                <button type="button" className="btn btn-info" onClick={() => abrirModalCIE10('cie10pc')}>
                                                    <i className="fas fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Modalidad de Atención *</label>
                                        <select name="modalidad_procedimiento" className="form-control" required>
                                            <option value="01">INTRAMURAL</option>
                                            <option value="02">EXTRAMURAL UNIDAD MÓVIL</option>
                                            <option value="03">EXTRAMURAL DOMICILIARIA</option>
                                            <option value="04">EXTRAMURAL JORNADA DE SALUD</option>
                                            <option value="06">TELEMEDICINA INTERACTIVA</option>
                                            <option value="07">TELEMEDICINA NO INTERACTIVA</option>
                                            <option value="08">TELEMEDICINA TELEXPERTICIA</option>
                                            <option value="09">TELEMEDICINA TELEMONITOREO</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Grupo de Servicios *</label>
                                        <select name="grupo_servicios_procedimientos" className="form-control" required>
                                            <option value="01">CONSULTA EXTERNA</option>
                                            <option value="02">APOYO DIAGNÓSTICO Y COMPLEMENTACIÓN TERAPÉUTICA</option>
                                            <option value="03">INTERNACIÓN</option>
                                            <option value="04">QUIRÚRGICO</option>
                                            <option value="05">ATENCIÓN INMEDIATA</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <SearchableSelect
                                        name="servicios_procedimientos"
                                        value={formData.servicios_procedimientos}
                                        onChange={handleInputChange}
                                        options={servicios}
                                        label="Servicios"
                                        placeholder="Seleccione un servicio..."
                                        required={true}
                                        helpText="Busque por código o nombre del servicio"
                                    />
                                </div>
                                <div className="col-md-12">
                                    <SearchableSelect
                                        name="finalidadprocedimiento"
                                        value={formData.finalidadprocedimiento}
                                        onChange={handleInputChange}
                                        options={finalidadProcedimiento}
                                        label="Finalidad Procedimiento"
                                        placeholder="Seleccione la finalidad..."
                                        helpText="Busque por código o nombre"
                                    />
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Concepto del Recaudo</label>
                                        <select name="conceptoRecaudo" className="form-control" required>
                                            <option value="05">NO APLICA</option>
                                            <option value="01">COPAGO</option>
                                            <option value="02">CUOTA MODERADORA</option>
                                            <option value="03">PAGOS COMPARTIDOS EN PLANES VOLUNTARIOS DE SALUD</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Valor Cuota Moderadora</label>
                                        <input type="number" name="valorpagomoderador" className="form-control" placeholder="0" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}



                <div className="row">
                    <div className="col-md-12">
                        <button type="submit" className="btn btn-info">
                            <i className="fas fa-save"></i> Guardar
                        </button>
                    </div>
                </div>
            </form>

            {/* Modal Consultas */}
            {showModalConsulta && (
                <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Seleccionar Código de Consulta</h5>
                                <button type="button" className="close" onClick={() => setShowModalConsulta(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th>Código</th>
                                                <th>Nombre</th>
                                                <th>Acción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {listaConsultas.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.codigorips}</td>
                                                    <td>{item.nombre}</td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-primary"
                                                            onClick={() => seleccionarConsulta(item.codigorips)}
                                                        >
                                                            Seleccionar
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModalConsulta(false)}>
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal Procedimientos */}
            {showModalProcedimiento && (
                <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Seleccionar Código de Procedimiento</h5>
                                <button type="button" className="close" onClick={() => setShowModalProcedimiento(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th>Código</th>
                                                <th>Nombre</th>
                                                <th>Acción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {listaProcedimientos.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.codigorips}</td>
                                                    <td>{item.nombre}</td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-primary"
                                                            onClick={() => seleccionarProcedimiento(item.codigorips)}
                                                        >
                                                            Seleccionar
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModalProcedimiento(false)}>
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal CIE10 */}
            <ModalCIE10
                show={showModalCIE10}
                onClose={() => setShowModalCIE10(false)}
                onSelect={seleccionarCIE10}
                title="Seleccionar Código CIE10 - Diagnóstico"
            />

            {/* Modal de Éxito */}
            {ripsGuardado && (
                <ModalRipsExito
                    show={showModalExito}
                    onClose={handleCerrarModal}
                    ripsData={ripsGuardado}
                    onDescargar={handleDescargar}
                    onEnviar={handleEnviar}
                />
            )}

        </div>
    );
}

export default RegistroRipsSinFev;